import React, { memo } from 'react';
import styled from '@emotion/styled';
import { m as motion } from 'framer-motion';
import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import { responsiveStyles } from '@polestar/component-warehouse-react/helpers/responsiveStyle';
import PauseButton from '@polestar/component-warehouse-react/components/pause-button/PauseButton';
import { ThemeProvider } from '@emotion/react';
import Themes from '@polestar/component-warehouse-react/themes/Themes';
const GalleryPauseButton = memo(({ videoRef, videoHeight, ariaLabels, isDark, ...props }) => (React.createElement(ThemeProvider, { theme: isDark ? Themes.dark : Themes.light }, (videoRef === null || videoRef === void 0 ? void 0 : videoRef.current) && (React.createElement(Container, { style: { height: videoHeight }, ...props },
    React.createElement(StyledPauseButton, { mediaRef: videoRef, ariaLabels: ariaLabels }))))));
GalleryPauseButton.displayName = 'GalleryPauseButton';
export default GalleryPauseButton;
const Container = styled(motion.div) `
  object-fit: contain;
  width: 100%;
  position: absolute;
  align-items: flex-end;
  justify-content: flex-end;
  display: flex;
  pointer-events: none;

  ${responsiveStyles({
    padding: {
        mobile: Spacings.small,
        tablet: Spacings.large,
        desktop: Spacings.large,
    },
})}
`;
const StyledPauseButton = styled(PauseButton) `
  pointer-events: auto;
`;
